/**
 * HomeSearchPanelContent — thin wrapper around canonical FeedSearchPanelContent.
 *
 * Binds the shared discovery/feed panel to Home's section enum and copy.
 */
import * as React from 'react';
import { Newspaper, Pin, Users } from 'lucide-react';
import {
  FeedSearchPanelContent,
  type FeedSectionShortcut,
} from '@bright-web-skeleton/ui';
import type { HomeSectionKey } from './HomeShortcutRail';

export interface HomeSearchPanelContentProps {
  searchQuery: string;
  onSearchQueryChange: (q: string) => void;
  onExecuteSearch: (explicitQuery?: string) => void;
  activeSections: HomeSectionKey[];
  onToggleSection: (section: HomeSectionKey) => void;
}

const SECTION_SHORTCUTS: FeedSectionShortcut<HomeSectionKey>[] = [
  { key: 'news', label: 'News', icon: Newspaper },
  { key: 'pinned', label: 'Pinned', icon: Pin },
  { key: 'following', label: 'Following', icon: Users },
];

export const HomeSearchPanelContent: React.FC<HomeSearchPanelContentProps> = (props) => (
  <FeedSearchPanelContent<HomeSectionKey>
    {...props}
    sectionShortcuts={SECTION_SHORTCUTS}
    recentSearchesKey="kloutforce-home"
    placeholder="Search home feed..."
  />
);

export default HomeSearchPanelContent;